var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-items-center tw-text-base tw-font-medium tw-text-black"},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }